import StoreService from "@/store";
import { EServices } from "@/types";
import JsonResponse from "@/utils/http/JsonResponse";
import JsonResponseClient from "@/utils/http/JsonResponseClient";
import { singleton, inject } from "tsyringe";

@singleton()
export default class HttpClient extends JsonResponseClient {
  constructor(@inject(EServices.store) private store: StoreService) {
    super(JsonResponse.createJsonResponse, process.env.VUE_APP_BASE_URL, {
      Authorization: () => this.getToken(),
    });
  }

  async getToken(): Promise<string> {
    return this.store.state.AccountModule.token !== null &&
      this.store.state.AccountModule.token !== undefined
      ? this.store.state.AccountModule.token
      : "";
  }
}
